<header class="navbar static">
  <div class="container-xl container-fluid">
    <a [href]="['./']" routerLinkActive="router-link-active" class="navbar-logo">
      <img src="assets/logo_dt.png" alt="Dental Tour Logo" class="logo-image" />
    </a>

    <span class="spacer"></span>

    <div class="navbar-buttons ">

      <div ngbDropdown class="language-selector" [display]="'dynamic'" [container]="'body'">
        <button class="btn  d-flex align-items-center gap-2 p-2 pe-0" type="button" id="languageDropdown"
          ngbDropdownToggle>
          <img [src]="Utils.getFlagSrc(currentLang)" class="flag-icon" alt="{{ Utils.getFlagName(currentLang) }} flag"
            [title]="Utils.getFlagName(currentLang)" [attr.aria-label]="Utils.getFlagName(currentLang)">
        </button>
        <div ngbDropdownMenu class="language-dropdown" aria-labelledby="languageDropdown">
          <button *ngFor="let lang of languages" ngbDropdownItem class="language-dropdown-item"
            (click)="onLanguageSelect(lang.code)" [class.active]="isCurrentLang(lang.code)">
            <div class="d-flex align-items-center justify-content-end py-1">
              <img [src]="Utils.getFlagSrc(lang.code)" class="flag-icon" alt="{{ Utils.getFlagName(lang.code) }} flag"
                [title]="Utils.getFlagName(lang.code)" [attr.aria-label]="Utils.getFlagName(lang.code)">
            </div>
          </button>
        </div>
      </div>

    </div>
  </div>
</header>